import React from 'react'
import {Field} from "formik";

type PropsType = {
    formikField?: boolean
    className?: string
    noClassName?: boolean
    children?: React.ReactNode
    id?: string
    value?: string | number
    onChange?: (e: any) => void
    name?: string
    disabled?: boolean
}

function FormSelect(props: PropsType) {
    const {
        formikField = true,
        className = '',
        children = null,
        noClassName = false,
        disabled = false,
        ...otherProps
    } = props


    let Tag: any = 'select'

    if (formikField) {
        Tag = Field
    }

    return (
        <Tag
            {...otherProps}
            as="select"
            disabled={disabled}
            className={`${noClassName ? '' : 'input'} ${className}`}>
            {children}
        </Tag>
    )
}

export default FormSelect
